module.exports = __webpack_public_path__ + "static/img/i2.0064a47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/i2.png
// module id = OxET
// module chunks = 0